"use strict";

define('model/attribute',['./base', 'datakit/collection'], function (BaseModel, DKCollection) {
  var AttributeModel = BaseModel.extend({
    childModels: {
      choices: BaseModel
    },
    defaults: function defaults() {
      return {
        choices: []
      };
    }
  }, {
    all: function all() {
      return this.createCollection('/rs/api/attribute');
    }
  });
  return AttributeModel;
});

